
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BillingAlertUnsynced',
  props: {
    billingBackendHandler: {
      type: String,
      required: true
    }
  }
})
